import Vue from 'vue';
import Router from 'vue-router';
import { getStore } from './store';
import AsyncComputed from 'vue-async-computed';
import vpnChecker from './tools/vpn-check';
import accountTabs from './routes/account-tabs';

import Track from './views/track/Track';
import Contest from './views/Contest';
import AcceptContest from './views/AcceptContest';
import CreateProject from './views/CreateProject';
import Account from './views/Account';
import Participant from './views/Participant';
import Portfolio from './views/Portfolio';
import AccountData from './views/AccountData';
import UserSearch from './views/UserSearch';
import UsersSearchFavorite from './components/user-search/UserSearchFavorites';
import UserSearchGeneralStatistics from './components/user-search/UserSearchGeneralStatistics';
import UserSearchProjectStatistics from './components/user-search/UserSearchProjectStatistics';
import UserSearchEducationStatistics from './components/user-search/UserSearchEducationStatistics';
import SingleProposal from './views/SingleProposal';
import TestingStart from './views/TestingStart';
import MultipleTestStart from './views/MultipleTestStart';
import MultipleSurveyStart from './views/MultipleSurveyStart';

import ExpertPanel from '@/views/expert-panel/ExpertPanel';
import ExpertPanelEvent from '@/views/expert-panel/ExpertPanelEvent';
import ExpertPanelSessionOld from '@/views/expert-panel-old/ExpertPanelSession';

import ProektoriaTest from './views/ProektoriaTest';

import Ratings from './views/Ratings';

import Invite from './views/Invite';
import Unsubscribe from './views/Unsubscribe';

import Stub from './views/Stub';
import RedirectToPortal from './views/RedirectToPortal';
import Portal from './components/Portal';
import Callback from '@/views/Callback';

import PageNotFound from './views/NotFound';

import { securityService } from './tools/sequrity_service';

//account-main
import AccountTrackTimeline from './views/AccountTrackTimeline';

import StartSession from './views/StartSession';
import TripChoice from './views/TripChoice';
import { parseHTML } from 'jquery';
import ExpertPanelReview from '@/views/expert-panel/ExpertPanelReview.vue';
import ExpertPanelReviewSuper from '@/views/expert-panel/ExpertPanelReviewSuper.vue';

Vue.use(Router);
Vue.use(AsyncComputed);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/portal',
            component: Portal,
            children: [
                {
                    name: 'education-info',
                    path: 'education-info/:component',
                    // component: EducationInfo,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'main',
                    path: 'main/:field',
                    // component: Main,
                    component: RedirectToPortal,
                    meta: { authRedirectAccount: true, requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: '',
                    name: 'portal-main',
                    redirect: { name: 'main', params: { field: 'growth' } },
                    meta: { authRedirectAccount: true, requiresAuth: false },
                },
                {
                    name: 'contests',
                    path: 'contests',
                    // component: Contests,
                    component: RedirectToPortal,
                    meta: { requiresAuth: true, redirectToPortal: true },
                },
                {
                    name: 'SPKPortal',
                    path: 'competition-system/:projectId',
                    meta: { requiresAuth: false },
                    redirect: (to) => ({ name: 'SPK', params: to.params }),
                },
                {
                    name: 'SPKPortalClean',
                    path: 'competition-system-clean/:projectId',
                    meta: { requiresAuth: false },
                    redirect: (to) => ({ name: 'SPKClean', params: to.params }),
                },
                {
                    name: 'Unsubscribe',
                    path: 'unsubscribe',
                    component: Unsubscribe,
                    meta: { requiresAuth: true },
                },
                {
                    name: 'contest',
                    path: 'contest/:id',
                    component: Contest,
                    meta: { requiresAuth: true },
                },
                {
                    name: 'accept-contest',
                    path: 'accept-contest/:id',
                    component: AcceptContest,
                    meta: { requiresAuth: true },
                },
                {
                    name: 'create-project',
                    path: 'create-project',
                    component: CreateProject,
                    meta: { requiresAuth: true },
                },
                {
                    name: 'participantPortal',
                    path: 'user/:id',
                    meta: { requiresAuth: false },
                    redirect: (to) => ({ name: 'participant', params: to.params }),
                },
                {
                    name: 'news',
                    path: 'news/:page(\\d+)?/:id?',
                    // component: News,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: 'pages/news',
                    redirect: { name: 'news' },
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                // {
                //     name: 'mentoring',
                //     path: 'mentoring/',
                //     // component: Mentoring,
                //     component: RedirectToPortal,
                //     meta: { requiresAuth: false, redirectToPortal: true },
                // },
                {
                    name: 'success',
                    path: 'success/:page(\\d+)?/:id?',
                    // component: Success,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'competences',
                    path: 'other-skills',
                    // component: Competences,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'competence',
                    path: 'other-skills/:id',
                    // component: Competence,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },

                {
                    name: 'testingPreList',
                    path: 'testing',
                    // component: TestList,
                    component: RedirectToPortal,
                    redirect: { name: 'testingList', params: { page: 1, categoryId: 'all' } },
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'testingList',
                    path: 'testing/:categoryId/:page',
                    // component: TestList,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'testingDetail',
                    path: 'test/:testId',
                    // component: TestDetail,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'testing-start',
                    path: 'test/start/:id',
                    component: TestingStart,
                    meta: { requiresAuth: true }, // RD-1086
                },
                {
                    name: 'multiple-test-start',
                    path: 'test/restart/:id',
                    component: MultipleTestStart,
                    meta: { requiresAuth: true }, // RD-1086
                },
                {
                    name: 'multiple-survey-start',
                    path: 'survey/restart/:id',
                    component: MultipleSurveyStart,
                    meta: { requiresAuth: true }, // RD-1086
                },
                {
                    name: 'competitions',
                    path: 'competitions/:type/:page(\\d+)?/:id?',
                    // component: Competitions,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: 'competitions',
                    redirect: { name: 'competitions', params: { type: 'contests' } },
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'profession-categories',
                    path: 'professions',
                    // component: ProfessionCategories,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'profession-list',
                    path: 'professions/list/:category?',
                    // component: Professions,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'profession-details',
                    path: 'professions/details/:professionId',
                    // component: SingleProfession,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'specialization-details',
                    path: 'specialization/details/:specializationId',
                    // component: SingleSpecialization,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                // {
                //     name: 'profession-program',
                //     path: 'professions/program/:id',
                //     component: ProfessionProgram,
                //     meta: { requiresAuth: true },
                // },
                {
                    name: 'professional-skills',
                    path: 'hard-skills',
                    // component: ProfSkills,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'professional-skill',
                    path: 'hard-skills/:id',
                    // component: ProfSkill,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'about-us',
                    path: 'about-us',
                    // component: AboutUs,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: 'about',
                    redirect: { name: 'about-us' },
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'about-team',
                    path: 'about-us/team',
                    // component: AboutUsTeam,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: 'persons/list',
                    redirect: { name: 'about-team' },
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'contacts',
                    path: 'contacts',
                    // component: Contacts,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'stub',
                    path: 'stub',
                    component: Stub,
                    meta: { requiresAuth: true },
                },
                {
                    path: 'supervisory-board',
                    name: 'supervisory-board',
                    // component: SupervisoryBoard,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'galleries',
                    path: 'gallery/:page(\\d+)?',
                    // component: Galleries,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'gallery',
                    path: 'gallery/',
                    // component: Gallery,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'gallery-post',
                    path: 'gallery/post/:id?/:page(\\d+)?',
                    // component: Gallery,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    name: 'start-session',
                    path: 'exam/start/:id',
                    component: StartSession,
                    meta: { requiresAuth: true }, // RD-1086
                },
                // New Events
                {
                    name: 'events',
                    path: 'edu/:type/:page(\\d+)?/:id?',
                    // component: Events,
                    component: RedirectToPortal,
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                {
                    path: 'education/',
                    redirect: 'education',
                    meta: { requiresAuth: false, redirectToPortal: true },
                },
                /* роут для выбора поездки БЧП */
                {
                    name: 'trip-chose',
                    path: 'trip-chose',
                    component: TripChoice,
                    meta: { requiresAuth: true },
                },
            ],
        },
        // Account
        {
            path: '/account/oauth',
            name: 'callback',
            component: Callback,
            meta: { isOidcRoute: true },
        },
        {
            name: 'account-edit',
            path: '/account/edit',
            component: AccountData,
            meta: { requiresAuth: true },
        },
        {
            name: 'account-user-search',
            path: '/account/user-search',
            component: UserSearch,
            meta: { requiresAuth: true },
            children: [
                {
                    name: 'favorites',
                    path: 'favorites',
                    component: UsersSearchFavorite,
                },
                {
                    name: 'general-statistics',
                    path: 'general-statistics',
                    component: UserSearchGeneralStatistics,
                },
                {
                    name: 'project-statistics',
                    path: 'project-statistics',
                    component: UserSearchProjectStatistics,
                },
                {
                    name: 'education-statistics',
                    path: 'education-statistics',
                    component: UserSearchEducationStatistics,
                },
            ],
        },
        {
            name: 'account-ratings',
            path: '/account/ratings',
            component: Ratings,
            meta: { requiresAuth: true },
        },
        {
            name: 'account-proposal-create',
            path: '/proposal/create',
            component: SingleProposal,
            meta: { requiresAuth: true },
        },
        {
            name: 'track',
            path: '/account/track',
            component: Track,
            meta: {
                requiresAuth: false,
                title: 'Трек возможностей',
            },
        },
        {
            name: 'account',
            path: '/account',
            component: Account,
            meta: { requiresAuth: true },
            // redirect: { name: 'account-profile' },
            redirect: () =>
                getStore().getters['isMobile'] || getStore().getters['isMobileApp']
                    ? { name: 'account-profile' }
                    : { name: 'account-main' },
            children: accountTabs(),
        },
        {
            name: 'participant-old',
            path: '/user/:id/old',
            component: Participant,
            meta: { requiresAuth: true },
        },
        {
            name: 'participant',
            path: '/user/:id',
            component: Portfolio,
            meta: { requiresAuth: true },
        },
        {
            name: 'ProektoriaTest',
            path: '/account/projectoryTest/:projectoryTestId',
            component: ProektoriaTest,
            meta: { requiresAuth: true },
        },
        {
            name: 'proposal',
            path: '/proposal/:id',
            component: SingleProposal,
            meta: { requiresAuth: true },
        },
        {
            name: 'account-track-timeline',
            path: '/account/track-timeline',
            component: AccountTrackTimeline,
            meta: { requiresAuth: true },
        },
        // Expert panel
        {
            name: 'expert-panel',
            path: '/expert-panel',
            component: ExpertPanel,
            meta: { requiresAuth: true },
        },
        {
            name: 'expert-panel-event',
            path: '/expert-panel/:type/:event',
            component: ExpertPanelEvent,
            meta: { requiresAuth: true },
        },
        {
            path: '/expert-panel/old/:type/:event/:session',
            component: ExpertPanelSessionOld,
            meta: { requiresAuth: true },
        },
        {
            path: '/expert-panel/:type/:event/:session',
            component: ExpertPanelReview,
            meta: { requiresAuth: true },
        },
        {
            path: '/expert-panel/:type/:event/:session/super',
            component: ExpertPanelReviewSuper,
            meta: { requiresAuth: true },
        },
        {
            path: '/expert-panel/:id',
            name: 'userProfileInAdmin',
            meta: { requiresAuth: true },
            beforeEnter(to) {
                window.open(`https://admin.${window.rsvDomain}/platform/users/${to.params.id}`, '_blank');
            },
        },

        {
            path: '/head-office',
            name: 'head-office',
            meta: { requiresAuth: true },
            beforeEnter(to) {
                window.location = '/head-office';
            },
        },
        // TODO: check
        {
            path: '/account/404',
            name: '404',
            component: PageNotFound,
            // beforeEnter(to) {
            //     window.location = '/404';
            // },
        },
        {
            name: 'Invite',
            path: '/invite/:hash/',
            component: Invite,
            meta: { requiresAuth: false },
        },
        {
            name: 'invite-redirect-post-logout',
            path: '/invite/redirect/post-logout/',
            meta: { requiresAuth: false },
            redirect: () => {
                let params = localStorage.getItem('post_logout_invite_state');
                if (params) {
                    params = JSON.parse(params);
                }
                return params && params.hash ? { name: 'Invite', params } : { name: 'portal-main' };
            },
        },
        {
            path: '*',
            redirect: { name: '404' },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.meta.redirectToPortal) {
        const prefix = '/portal';
        if (to.fullPath.startsWith(prefix)) {
            window.location.replace(to.fullPath.slice(prefix.length));
        }
    }

    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = 'Россия — страна возможностей';
    }

    if (to.query.is_mobile_app && to.query.is_mobile_app === 'true') {
        getStore().commit('setIsMobileApp', true);
    }

    if (!to.meta.isOidcRoute && !getStore().getters['auth/isAuthorized']) {
        securityService.checkAuth({ requiresAuth: to.meta.requiresAuth }).then((user) => {
            if (to.meta.requiresAuth && !user) {
                getStore().commit('auth/setHasAccess', false);
            }
            next();
        });
    } else {
        return next();
    }
});

router.afterEach(() => {
    vpnChecker();
});

router.afterEach(() => {
    if (!window.rsvNoRouteScroll) {
        window.scrollTo({ top: 0 });
    }
});

export default router;
